module.exports = __webpack_public_path__ + "static/media/data_management_tool.919b754b.svg";